<div class="kissati-page">
  <app-loader [isLoading]="isLoading"></app-loader>

  <div class="container mx-auto px-4 py-8">
    <div class="logo-container">
      <img
        src="assets/icons/logoKissati.png"
        alt="Logo Kissati"
        class="logo-kissati"
      />
    </div>

    <app-children-selector
      [autoSelectFirst]="true"
      (studentSelected)="onStudentSelected($event)"
      (studentsLoaded)="onStudentsLoaded($event)"
    >
    </app-children-selector>

    <div *ngIf="isLoading" class="loading">
      {{ "kissati.loading" | translate }}
    </div>

    <div *ngIf="error" class="error">{{ error }}</div>

    <div class="books-grid" *ngIf="!isLoading && !error && books.length === 0">
      {{ "kissati.noBooks" | translate }}
    </div>
    <div class="flex justify-center my-6">
      <div class="flex w-full max-w-lg">
        <input
          type="text"
          [(ngModel)]="searchValue"
          placeholder="{{ 'kissati.searchPlaceholder' | translate }}"
          class="input-search"
        />

        <button
          (click)="onSearch()"
          class="ml-2 px-4 py-2 text-white rounded"
          style="background-color: #eaa962"
        >
          🔍
        </button>
      </div>
    </div>

    <div class="books-grid">
      <div *ngFor="let book of books" class="book-card">
        <a
          [href]="'https://9issati.net/bookPlayMobile?bookId=' + book.id"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="imgBx">
            <img [src]="book.url_image" [alt]="book.title" />
          </div>
          <div class="details">
            <p class="book-button">{{ book.title }}</p>
          </div>
        </a>
      </div>
    </div>

    <!-- Pagination -->
    <div
      class="pagination-simple"
      *ngIf="!isLoading && !error && totalPages > 1"
    >
      <button
        class="btn-prev"
        (click)="previousPage()"
        [disabled]="currentPage === 1"
      >
        {{ "kissati.previous" | translate }}
      </button>
      <button
        class="btn-next"
        (click)="nextPage()"
        [disabled]="currentPage === totalPages"
      >
        {{ "kissati.next" | translate }}
      </button>
    </div>
  </div>
</div>
